import { KeypadContext } from '@3plearning/question-components-library';
import { Box, Button, Img } from '@chakra-ui/react';
import { t } from '@lingui/macro';
import React, { useContext } from 'react';

import keypadIcon from '../../assets/images/keypad.svg';

export const Keypad = () => {
  const {
    showKeypad, setShowKeypad, showKeypadBtn, isKeypadBtnDisabled
  } = useContext(KeypadContext);
  const toggleKeypad = (event) => {
    event.preventDefault();
    setShowKeypad(!showKeypad);
  };

  if (!showKeypadBtn) {
    return null;
  }

  return (
    <Button
      w={'42px'}
      h={'42px'}
      left={0}
      bottom={'40px'}
      transform={'translate(-50%, 0)'}
      zIndex={1}
      position={'absolute'}
      variant={'read-aloud'}
      title={t`Toggles keypad`}
      aria-label={t`Toggles keypad`}
      onMouseDown={toggleKeypad}
      isDisabled={isKeypadBtnDisabled}
      isActive={showKeypad && !isKeypadBtnDisabled}
      _active={{ bg: 'primary.300' }}
      _disabled={{
        _hover: { bg: 'neutral.100' },
        bg: 'neutral.100',
        borderColor: 'neutral.200',
        cursor: 'not-allowed'
      }}
    >
      <Box as={'span'} borderRadius={'4px'} bg={'white'}><Img src={keypadIcon} mr={'-1px'} my={'-1px'} /></Box>
    </Button>
  );
};
